import React from 'react';
import WName from '../../../../WName';
import PL from '../../../../problems/ProblemLink';
import QL from '../../../../faq/QuestionLink';
import AL from '../../../../angles/AngleLink';
import NW from '../../../../neologisms/NewWord';
import OML from '../../../../ormaybe/OrMaybeLink';
import LRL from '../../../LongReadLink';
import {E1, E2, Qual} from '../../../../common';

// ‘’ … –

export const e_ma = {
  name: "e-ma",
  prelude: <span>
    If there is no <i><PL name="ignorabimus">unknowable</PL></i>,
  </span>,
  header: <span>
    E<sub><i>म</i></sub> (E-ma: 1, 0, 1, 0, 1, 0, …) = ????
  </span>,
  preview: <div className="long-read-preview">
    <p>‘It comes to E<sub><i>म</i></sub> (E-ma),’ Maya said, and shei wheeled heri <NW>khet</NW> to a blackboard and wrote:</p>
    <p>E<sub><i>म</i></sub> = (1, 0, 1, 0, 1, 0, …)</p>
    <p>‘It was named that because you’d obviously pass it at some point if actually <i>counting</i> to infinity,’ said Amara. ‘The म (ma) was for मध्य (madhya) – a <QL name="languages">Sanskrit</QL> word for “middle”.’</p>
    <p>‘But <PL name="poiocentrism">who</PL> would expect it to have an exact, finite <i>value</i>?’ <PL name="ch.">Lockie</PL> said, entering the fray.</p>
    <p>‘Even feathery Io could figure out that one,’ said <PL name="ch.">Rugala</PL>, riding in on Lockie’s (<NW>khet</NW>’s) back. Siffstag feathery-shrugged. (For the standing <PL>characters</PL> siffstag was ‘siffstag’; in the <QL>Gippetian</QL> pronoun <PL name="ick.">system</PL>, laying on the back of an ‘<QL>other</QL>’ counts at ‘sitting’, even if that ‘<QL>other</QL>’ was standing.) Rugala said, ‘You just need something that turns a “1, 0” into a “1, 1” to close up those gaps and make it all ones: <LRL name="nepantla.sa.e-omega">E<sub><i>ω</i></sub></LRL>.’</p>
    <p>‘That thing you need is the binary set of two ones followed by infinite zeroes,’ Amara said. ‘E<sub>3</sub> – or, you know, three.’</p>
    <p>Maya wrote on the board:</p>
    <p style={{fontFamily: "courier"}}>
E<sub><i>म</i></sub> × E<sub>3</sub>:<br />
10101010…<br />
<u>11000000 ×</u><br />
1010101010…<br />
<u>_101010101… +</u><br />
1111111111…</p>
    <p>‘So if you multiply it by three and it generates E<sub><i>ω</i></sub> – and <LRL name="nepantla.sa.e-omega">E<sub><i>ω</i></sub></LRL> is the “scaly arithmetic” <i><PL name="form">representation</PL></i> of –1 (minus one),’ <PL name="ch.maire">Máire</PL> said, coming in, ‘then it only makes <AL name="fields.logic">logical</AL> sense that E<sub><i>म</i></sub> = –⅓ (minus one-third).’</p>
    <p>‘QED,’ Uwa said, and stagsiff went out to get an <QL name="silly.ice cream">ice-cream bar</QL>.</p>
  </div>,
//  text: <div className="long-read-text">
//  </div>,
};

// ½ ⅓ ⅔ ¼ ¾ ⅕ ⅖ ⅗ ⅘ ⅙ 
